import { defineStore } from 'pinia'

// 用户状态管理
export const useUserStore = defineStore('user', {
  state: () => ({
    // 用户信息
    userInfo: {
      id: null as number | null,
      name: '',
      email: '',
      avatar: ''
    },
    // 登录状态
    isLoggedIn: false,
    // 权限信息
    permissions: [] as string[]
  }),

  getters: {
    // 获取用户信息
    getUserInfo: (state) => state.userInfo,
    // 检查是否登录
    getLoginStatus: (state) => state.isLoggedIn,
    // 检查是否有特定权限
    hasPermission: (state) => (permission: string) => state.permissions.includes(permission)
  },

  actions: {
    // 设置用户信息
    setUserInfo(userData: any) {
      this.userInfo = { ...this.userInfo, ...userData }
      this.isLoggedIn = true
    },

    // 清除用户信息（退出登录）
    clearUserInfo() {
      this.userInfo = {
        id: null,
        name: '',
        email: '',
        avatar: ''
      }
      this.isLoggedIn = false
      this.permissions = []
    },

    // 设置权限
    setPermissions(permissions: string[]) {
      this.permissions = permissions
    },
    
    // 退出登录（clearUserInfo的别名）
    logout() {
      this.clearUserInfo()
    }
  },

  // 持久化配置
  persist: true
})